export const state = {
    promotions: {
        data: [],
        total: 0,
        per_page: 50,
    },
    per_page: 50,
};
